import { useEffect, useMemo } from 'react'

import {
  AuditLog,
  GroupedByDay,
  PIIAuditTrail,
  PIIAuditTrailMetadataArgs,
  getPIIAuditTrailListMetadata,
} from '../../assets/ts/data/pii/pii-audit-trail'
import { convertDate } from '../../assets/ts/date-and-time/date-and-time'
import useServerData from '../use-server-data'
// Adjust the path as necessary
function usePiiAuditTrailMetadata(fetchArgs, waitOnParentDependency = false) {
  const {
    data: piiAuditTrailMetadata,
    error: piiAuditTrailMetadataError,
    fetchData: fetchPiiAuditTrailMetadata,
    isLoading: piiAuditTrailMetadataIsLoading,
  } = useServerData<PIIAuditTrail, PIIAuditTrailMetadataArgs>(
    getPIIAuditTrailListMetadata,
    fetchArgs,
    waitOnParentDependency
  )

  const groupAuditsByDay = (
    audits: AuditLog[]
  ): { [key: string]: AuditLog[] } => {
    return audits.reduce((acc, date) => {
      const day = new Date(date.ItemCreated).toISOString().split('T')[0] // Extract the day part
      if (!acc[day]) {
        acc[day] = []
      }
      acc[day].push(date)
      return acc
    }, {} as { [key: string]: AuditLog[] })
  }

  const convertObjectToArray = (groupedObject: {
    [key: string]: AuditLog[]
  }): GroupedByDay[] => {
    return Object.entries(groupedObject).map(([day, auditByDates]) => ({
      auditByDates,
      day,
    }))
  }

  const formatPIIAuditLogs = (audits: any[]): GroupedByDay[] => {
    const newAuditFormat: AuditLog[] = audits.map((audit): AuditLog => {
      return {
        Audit: audit,
        AuditTime: convertDate(audit.ItemCreated, 'Time'),
        ItemCreated: audit.ItemCreated,
      }
    })

    const groupedByDay = groupAuditsByDay(newAuditFormat)
    return convertObjectToArray(groupedByDay)
  }

  // const refactoredPIIAuditData: GroupedByDay[] = formatPIIAuditLogs(
  //   piiAuditTrailMetadata
  // )
  const refactoredPIIAuditData = useMemo(() => {
    return piiAuditTrailMetadata
      ? formatPIIAuditLogs(piiAuditTrailMetadata)
      : []
  }, [piiAuditTrailMetadata])
  return {
    fetchPiiAuditTrailMetadata,
    piiAuditTrailMetadata,
    piiAuditTrailMetadataError,
    piiAuditTrailMetadataIsLoading,
    refactoredPIIAuditData,
  }
}

export default usePiiAuditTrailMetadata
